import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import Button from '../components/Button';
import { Modal, ModalName, ModalPart } from '../components/Modal';
import { useToast } from '../components/Toast';
import { deleteTagCache } from '../utilities/cache';
import { DELETE_TAG } from '../utilities/mutations';

const DeleteTagModal = ({ tagId, tagName, onClose }) => {
  const params = useParams();
  const toast = useToast();
  const [deleteTag] = useMutation(DELETE_TAG);

  const close = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal onClose={() => close()} isDanger>
      <ModalName>Delete tag</ModalName>
      <ModalPart>Are you sure you want to delete this tag?</ModalPart>
      <ModalPart>
        <Button onClick={() => close()} isExtended>
          Cancel
        </Button>
        <Button
          onClick={async () => {
            try {
              await deleteTag({
                variables: { id: tagId },
                update: (cache) => deleteTagCache(params.s, cache, tagId),
              });
              toast({ children: `${tagName} tag deleted` });
              close();
            } catch (error) {
              toast({ children: error.message });
            }
          }}
          isDanger
          isExtended
        >
          Delete
        </Button>
      </ModalPart>
    </Modal>
  );
};

export default DeleteTagModal;
